import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoginRequest } from '@models/login/login-model.model copy';
import { TokenModel } from '@models/login/token-model.model';
import { LoginService } from '@services/login/login.service';
import { UsuarioDto } from '@models/usuario/usuarioDto.model'
import { Router, RouterModule } from '@angular/router';
import { UsuarioService } from '@services/usuario/usuario.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { PersonaDetailDto } from '@models/persona/personaDetailDto.model';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PermisoService } from '@services/permiso/permiso.service';
import { PermisoDto } from '@models/seguridad/permisos/permisoDto.model';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule,  A11yModule, CommonModule, MatExpansionModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, MatCheckboxModule, MatAutocompleteModule, MatChipsModule, MatTabsModule, DragDropModule, MatSidenavModule,MatListModule,RouterModule],
  selector: 'app-iniciar-sesion',
  templateUrl: './iniciar-sesion.component.html',
  styleUrls: ['./iniciar-sesion.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class IniciarSesionComponent implements OnInit {
  submitted = false;
  loginForm: FormGroup;
  tokenModel: TokenModel = new TokenModel
  loginRequest: LoginRequest = new LoginRequest
  public personaDetailDto: PersonaDetailDto = new PersonaDetailDto;
  UsuarioDto: UsuarioDto = new UsuarioDto;
  idPersona: number = 0;
  isLoading: boolean = false;
  loginTrue: boolean = false;
  formBuilder: FormBuilder = new FormBuilder;
  permisoDto!:PermisoDto[];
  get f() { return this.loginForm.controls; }
  modoRecuperacion = false;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private userService: UsuarioService,
    private permisoService: PermisoService,
    private snackBar: SnackBarService
  ) {

    this.loginForm = this.formBuilder.group({
      Usuario: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      Clave: ['', Validators.compose([Validators.required])],
    })
  }

  ngOnInit(): void {
  }

  loguearse() {
    this.isLoading = true;
    this.submitted = true;

    if (this.loginForm.invalid) {
      this.snackBar.showWarn("Formulario invalido.", "")
      return;
    }

    if (this.loginForm.valid == true) {
      this.submitted = true;
      this.loginRequest.userName = this.loginForm.controls["Usuario"].value
      this.loginRequest.password = btoa(this.loginForm.controls["Clave"].value)//Encripta en base64

      this.loginService.login(this.loginRequest)
        .subscribe(
          tokenModel => {
            this.isLoading = false
            this.loginTrue = true
            this.recibirToken(tokenModel)
            this.obtenerUsuario(this.loginRequest.userName)
          },
          error => {
            this.isLoading = false
            this.snackBar.showError(error, "")
          }
        )

    }

  }

  obtenerUsuario(userName: string) {
    this.isLoading = true
    this.userService.getAllDataOfUserByUserName(userName).subscribe(
      data => {
        this.UsuarioDto = data
        this.loginService.setCurrentUser(data)
        if (this.UsuarioDto.activo == false || this.UsuarioDto.id == 0) {
          this.loginService.logout()
          this.router.navigateByUrl("/login")
          this.snackBar.showWarn("Usuario dado de baja.", "")
          this.isLoading = false
        }
        else {
          // No se debe llamar a setCurrentUser con data aquí, ya que data es PermisoDto[]
          if (this.UsuarioDto.changePassword == true) {
            this.snackBar.showInfo("Asegurese de cambiar su contraseña.", "")
          }
          if(this.UsuarioDto?.rol)
            this.obtenerPermisos(this.UsuarioDto.rol.id)
        }
      },
      error => {
        this.snackBar.showError(error, "Error");
      })
  }

  obtenerPermisos(idRol: number) {
    this.isLoading = true
    if (idRol) {
      this.permisoService.initializePermissions(idRol)
        .then(() => {
          this.router.navigate(["/cargando"])
        })
        .catch((error) => {
         this.snackBar.showError(error, "Error");
        });
    }
  }


  recibirToken(tokenModel: TokenModel) {
    if (tokenModel != null) {
      this.loginService.setToken(tokenModel);
    }
  }
}

